import { ContainerPainel } from './container_painel';

export { ContainerPainel };
export default ContainerPainel;
